import { createAppConfigFromEnv } from '@elva/platform';

export const aiReceptionistPlatformConfig = createAppConfigFromEnv(import.meta.env, {
  appName: 'Elva AI Receptionist',
  tokenKey: 'elva_auth_token',
  loginCallbackPath: '/loginok',
  publicPathPrefix: '/public',
});
